import { IKyHieuHoaDonActionTypes } from "../../action-types/hoa-don/IKyHieuHoaDonAction";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKyHieuHoaDonReducer } from "../../reducer-model/hoa-don/IKyHieuHoaDonReducer";
const iniState: IKyHieuHoaDonReducer = {
  status: eReducerStatusBase.is_not_initialization,
  kyHieuHoaDons: [],
  idSelections: [],
};
export const kyHieuHoaDonReducer = (
  state: IKyHieuHoaDonReducer = iniState,
  action: IKyHieuHoaDonActionTypes
): IKyHieuHoaDonReducer => {
  switch (action.type) {
    case "KY_HIEU_HOA_DON_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "KY_HIEU_HOA_DON_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        kyHieuHoaDons: action.payload,
      };
    case "KY_HIEU_HOA_DON_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "KY_HIEU_HOA_DON_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "KY_HIEU_HOA_DON_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "KY_HIEU_HOA_DON_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "KY_HIEU_HOA_DON_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "KY_HIEU_HOA_DON_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "KY_HIEU_HOA_DON_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "KY_HIEU_HOA_DON_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        kyHieuHoaDonEditing: action.payload,
      };
    case "KY_HIEU_HOA_DON_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        kyHieuHoaDonEditing: undefined,
      };
    default:
      return state;
  }
};
